import { createMuiTheme } from '@material-ui/core';
import arrow from 'assets/images/icons/arrow.svg';

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    MuiPickersToolbar: {
      toolbar: React.CSSProperties;
    };
  }
}
const style = {
  typography: {
    fontFamily: "'Noto Sans',sans-serif",
    color: 'rgba(9, 21, 38, 0.85)',
  },
  overrides: {
    MuiFormControl: {
      root: {
        width: '220px',
      },
    },
    MuiAutocomplete: {
      listbox: {
        padding: 0,
      },
      option: {
        margin: 0,
        padding: '15px 10px !important',
        fontSize: 16,
        lineHeight: 1,
        '&:hover': {
          background: 'rgb(222, 239, 243)',
          cursor: 'pointer',
        },
      },
      paper: {
        margin: 0,
      },
      popper: {
        zIndex: 1,
      },
    },
    MuiInputBase: {
      root: {
        height: '50px',
        backgroundColor: '#fff',
        borderRadius: '10px',
        fontFamily: "'Noto Sans',sans-serif",
        border: '2px solid rgba(9, 21, 38, 0.6)',
        paddingLeft: '12px',
        '&.Mui-focused': {
          border: '2px solid #12B7E7',
        },
      },
      input: {
        color: 'rgba(9, 21, 38, 0.85)',
        fontSize: '16px',
        lineHeight: '22px',
        padding: 0,
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          content: 'none',
        },
        '&:after': {
          content: 'none',
        },
      },
    },
    MuiIconButton: {
      root: {
        background: 'transparent !important',
      },
    },
    MuiButtonBase: {
      root: {
        margin: '2px',
      },
    },
    MuiMenuItem: {
      root: {
        margin: 0,
        padding: '15px 10px !important',
        fontSize: 16,
        lineHeight: 1,
        '&:hover': {
          background: 'rgb(222, 239, 243)',
          cursor: 'pointer',
        },
      },
    },
    MuiToolbar: {
      root: {
        backgroundColor: '#9965F4',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#fff',
        height: '45px',
        minHeight: '40px',
        borderBottom: '1px solid rgba(0,0,0, .16)',
        overflow: 'hidden',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: '0',
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: 'rgba(0,0,0, .85)',
      },
      toolbarBtnSelected: {
        color: 'rgba(0,0,0, .85)',
      },
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        flex: '1 0 100%',
        width: '100%',
        paddingTop: '8px',
        margin: '0',
        '&:after': {
          content: '""',
          display: 'block',
          width: '24px',
          height: '24px',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundImage: `url(${arrow})`,
          transform: 'rotate(90deg)',
          position: 'absolute',
          right: '110px',
        },
      },
    },
    MuiPickersCalendar: {
      transitionContainer: {
        borderTop: '1px solid rgba(0,0,0, .16)',
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#12B7E7',
        '&:hover': {
          backgroundColor: '#00A8D9',
        },
        '&:focus': {
          backgroundColor: '#00A8D9',
        },
      },
    },
  },
  props: {
    MuiIconButton: {
      disableRipple: true,
    },
    MuiList: {
      disablePadding: true,
    },
  },
};
export const theme = createMuiTheme(style);
